import {useNavigate, useParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import routes from '../../../../../Routes/routes';
import {useEffect, useState} from 'react';
import {
    GetIdentityValidationType,
} from '../../../../../reduxToolkit/Visitor/VisitorApi';
import { IDENTITY_VALIDATION_TYPE_MODEL} from '../../Visitor/Model/Model';
import {GetInvitationById} from '../../../../../reduxToolkit/Invitation/InvitationApi';
import {getUrlParameters} from "../Model/Model";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const IdentityValidationApp = () => {

    const { id, guardFlowId } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { getInvitationById } = useSelector((state) => state.InvitationSlice);

    const [isAutomatic, setIsAutomatic] = useState(false);
    const [disabledBtnNext, setDisabledBtnNext] = useState(true);

    useEffect(() => {
        dispatch(GetIdentityValidationType()).then(({ payload: { data: { data } } }) => {
            setIsAutomatic(IDENTITY_VALIDATION_TYPE_MODEL.VERIDAS.id ==  data);
            setDisabledBtnNext(false)
        });
    }, []);

    useEffect(() => {
        if (!getInvitationById || getInvitationById?.length <= 0) {
            dispatch(GetInvitationById(id));
        }
    }, [id]);

    const getUrlNext = () => {
        if( isAutomatic ) {
            navigate(getUrlParameters({ url: routes.invitationDetails.chooseValidationType, id, guardFlowId }));
        } else {
            const fileType = getInvitationById?.fileType != null ? getInvitationById.fileType : null;
            navigate(fileType != null ? getUrlParameters({ url: (routes.invitationDetails.createExternal + fileType + "/"), id, guardFlowId }) : getUrlParameters({ url: routes.invitationDetails.chooseValidationType, id, guardFlowId }))
        }
    }

    return {
        id,
        guardFlowId,
        t, getInvitationById,
        getUrlNext,
        disabledBtnNext
    }

}

export default IdentityValidationApp
